var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.97299H20M10.584 7.33756V18.0061M6.69391 7.37266L7.36676 18.0413M14.474 7.37266L13.8012 18.0413M18.5459 3.97299L16.9162 21H4.25184L2.62223 3.97299H18.5459ZM6.69396 3.97299L7.84956 1H13.3185L14.474 3.97299H6.69396Z",
    stroke: "#0C6CDE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlue);
export default __webpack_public_path__ + "static/media/Delete_Blue.fe48b80da35cb939d9ca2280648d050a.svg";
export { ForwardRef as ReactComponent };